"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _config = _interopRequireDefault(require("./config"));

var _promiseQueue = _interopRequireDefault(require("@px/promise-queue"));

var _util = require("@ux/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var queue = new _promiseQueue["default"]();
var _default = {
  queue: queue,
  basket: {
    get: function get() {
      var requestKey = Math.floor(Math.random() * 1000000000 + 1);
      return fetch(new _util.URL(_config["default"].urls.basketApiGet).set('query', {
        r: requestKey
      }).toString(), {
        method: 'GET',
        credentials: 'include'
      }).then(function (response) {
        return response.json();
      }).then(function (basket) {
        if (basket) {
          basket.requestKey = requestKey;
        }

        return basket || {};
      })["catch"](function () {
        return {};
      });
    },
    patch: function patch(payload) {
      return queue.push(function () {
        return fetch(_config["default"].urls.basketApiPatch, {
          method: 'PATCH',
          credentials: 'include',
          body: JSON.stringify(payload)
        });
      });
    },
    "delete": function _delete(item) {
      return queue.push(function () {
        return fetch(new _util.URL(_config["default"].urls.basketApiDelete).set('query', {
          itemId: item.itemId
        }).toString(), {
          method: 'DELETE',
          credentials: 'include'
        });
      });
    }
  }
};
exports["default"] = _default;